var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Page", {
        attrs: { title: _vm.pageTitle, isFullWidth: true },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function() {
              return [
                _c("div", { staticClass: "Polaris-ActionMenu" }, [
                  _c(
                    "div",
                    {
                      staticClass: "Polaris-ActionMenu-Actions__ActionsLayout"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "Polaris-ButtonGroup Polaris-ButtonGroup--extraTight"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "Polaris-ButtonGroup__Item" },
                            [
                              _c("span", {}, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "Polaris-Button",
                                    attrs: { type: "button" },
                                    on: { click: _vm.openTemplates }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "Polaris-Button__Content"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "Polaris-Button__Text"
                                          },
                                          [_vm._v("Templates")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "Polaris-Page-Header__PrimaryActionWrapper" },
                  [
                    _c(
                      "div",
                      { staticClass: "Polaris-Box Polaris-Box--printHidden" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "Polaris-Button Polaris-Button--primary",
                            attrs: { type: "button", disabled: _vm.isLoading },
                            on: { click: _vm.refreshCurrentPage }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "Polaris-Button__Content" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "Polaris-Button__Text" },
                                  [
                                    _vm._v("Refresh"),
                                    _vm.isLoading
                                      ? _c("span", [_vm._v("ing")])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col max-w-7xl mx-auto my-10" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
                      },
                      [
                        _vm.isLoading
                          ? _c("div", [_c("Spinner")], 1)
                          : _vm._e(),
                        _c("div", {}, [
                          _c("div", {}, [
                            _c("div", [
                              _c("div", {}, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "Polaris-Labelled__LabelWrapper"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "Polaris-Label" },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "Polaris-Label__Text",
                                            attrs: {
                                              id: "PolarisTextField1Label",
                                              for: "PolarisTextField1"
                                            }
                                          },
                                          [_vm._v("Search By Order Id")]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "Polaris-Connected" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "Polaris-Connected__Item Polaris-Connected__Item--primary flex"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "Polaris-TextField Polaris-TextField--hasValue flex-1 mr-2"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.searchText,
                                                  expression: "searchText"
                                                }
                                              ],
                                              staticClass:
                                                "Polaris-TextField__Input Polaris-TextField__Input--hasClearButton",
                                              attrs: {
                                                id: "PolarisTextField1",
                                                autocomplete: "off",
                                                type: "text",
                                                "aria-labelledby":
                                                  "PolarisTextField1Label",
                                                "aria-invalid": "false",
                                                placeholder: "Enter Order Id"
                                              },
                                              domProps: {
                                                value: _vm.searchText
                                              },
                                              on: {
                                                keydown: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.loadPage(1)
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.searchText =
                                                    $event.target.value
                                                }
                                              }
                                            }),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "Polaris-TextField__ClearButton",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.searchText = ""
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "Polaris-Text--root Polaris-Text--visuallyHidden"
                                                  },
                                                  [_vm._v("Clear")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "Polaris-Icon Polaris-Icon--colorBase Polaris-Icon--applyColor"
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass:
                                                        "Polaris-Text--root Polaris-Text--visuallyHidden"
                                                    }),
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "Polaris-Icon__Svg",
                                                        attrs: {
                                                          viewBox: "0 0 20 20",
                                                          focusable: "false",
                                                          "aria-hidden": "true"
                                                        }
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            "fill-rule":
                                                              "evenodd",
                                                            d:
                                                              "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-2.293 4.293a1 1 0 0 0-1.414 1.414l2.293 2.293-2.293 2.293a1 1 0 1 0 1.414 1.414l2.293-2.293 2.293 2.293a1 1 0 1 0 1.414-1.414l-2.293-2.293 2.293-2.293a1 1 0 0 0-1.414-1.414l-2.293 2.293-2.293-2.293z"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass:
                                                "Polaris-TextField__Backdrop"
                                            })
                                          ]
                                        ),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "Polaris-Button",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                return _vm.loadPage(1)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "Polaris-Button__Content"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "Polaris-Button__Text"
                                                  },
                                                  [_vm._v("Search")]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "flex flex-col" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
                            },
                            [
                              _c("ManualMessageAlert"),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "align-middle inline-block min-w-full shadow  sm:rounded-lg border-b border-gray-200 mb-24"
                                },
                                [
                                  _c("div", { staticClass: "Polaris-Card" }, [
                                    _c("div", {}, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "Polaris-DataTable__Navigation"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "Polaris-Button Polaris-Button--disabled Polaris-Button--plain Polaris-Button--iconOnly",
                                              attrs: {
                                                "aria-label":
                                                  "Scroll table left one column",
                                                "aria-disabled": "true",
                                                type: "button",
                                                tabindex: "-1"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "Polaris-Button__Content"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "Polaris-Button__Icon"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "Polaris-Icon"
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                                          }),
                                                          _c(
                                                            "svg",
                                                            {
                                                              staticClass:
                                                                "Polaris-Icon__Svg",
                                                              attrs: {
                                                                viewBox:
                                                                  "0 0 20 20",
                                                                focusable:
                                                                  "false",
                                                                "aria-hidden":
                                                                  "true"
                                                              }
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  d:
                                                                    "M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293a.999.999 0 0 1-.707 1.707z"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "Polaris-Button Polaris-Button--plain Polaris-Button--iconOnly",
                                              attrs: {
                                                "aria-label":
                                                  "Scroll table right one column",
                                                type: "button"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "Polaris-Button__Content"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "Polaris-Button__Icon"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "Polaris-Icon"
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                                          }),
                                                          _c(
                                                            "svg",
                                                            {
                                                              staticClass:
                                                                "Polaris-Icon__Svg",
                                                              attrs: {
                                                                viewBox:
                                                                  "0 0 20 20",
                                                                focusable:
                                                                  "false",
                                                                "aria-hidden":
                                                                  "true"
                                                              }
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  d:
                                                                    "M8 16a.999.999 0 0 1-.707-1.707l4.293-4.293-4.293-4.293a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5a.997.997 0 0 1-.707.293z"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "Polaris-DataTable Polaris-DataTable__ShowTotals overflow-auto"
                                        },
                                        [
                                          _c("div", {}, [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "Polaris-DataTable__Table"
                                              },
                                              [
                                                _c("thead", [
                                                  _c(
                                                    "tr",
                                                    {
                                                      staticClass:
                                                        "hidden md:table-row"
                                                    },
                                                    [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [_vm._v(" Order ")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [_vm._v(" Date ")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Customer Name "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [_vm._v(" Total ")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [_vm._v(" Payment ")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Fulfillment "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Message Sent "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                          attrs: {
                                                            "data-polaris-header-cell":
                                                              "true",
                                                            scope: "col"
                                                          }
                                                        },
                                                        [_vm._v(" Tags ")]
                                                      ),
                                                      _c("th", {
                                                        staticClass:
                                                          "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                        attrs: {
                                                          "data-polaris-header-cell":
                                                            "true",
                                                          scope: "col"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.orders.docs,
                                                    function(order) {
                                                      return _c("OrderItem", {
                                                        key: order.id,
                                                        attrs: {
                                                          order: order,
                                                          "shop-origin":
                                                            _vm.shopOrigin
                                                        },
                                                        on: {
                                                          refreshCurrentPage:
                                                            _vm.refreshCurrentPage,
                                                          openCustomerInfo:
                                                            _vm.openCustomerInfo
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              ]
                                            )
                                          ]),
                                          _c("Pagination", {
                                            attrs: { page: _vm.orders },
                                            on: { pageChanged: _vm.loadPage }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              !_vm.isLoading &&
                              _vm.orders.docs &&
                              _vm.orders.docs.length === 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                                    },
                                    [
                                      _vm._v(
                                        " You don't have any order right now. We will be listing them here as soon as order is placed. "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm.showCustomerInfoModal
                          ? _c("CustomerInfoModal", {
                              attrs: {
                                phoneNumber: _vm.currentCustomerPhoneNumber
                              },
                              on: { close: _vm.closeCustomerInfo }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("div", { staticClass: "Polaris-FooterHelp" }, [
                      _c("div", { staticClass: "Polaris-FooterHelp__Text" }, [
                        _vm._v(" Learn more about "),
                        _c(
                          "a",
                          {
                            staticClass: "Polaris-Link",
                            attrs: {
                              target: "blank",
                              href:
                                "https://app.tango.us/app/workflow/f9980f94-b15c-4dac-a60a-32694259d61f",
                              "data-polaris-unstyled": "true"
                            }
                          },
                          [_vm._v("Manual Order Messages")]
                        )
                      ])
                    ])
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }